import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'nrwl-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  @Input() totalResult: number;
  @Input() displayPager = true;
  @Input() defaultPageSize = 10;
  @Input() hidePageSizer = false;
  @Input() pageSizeOptionData = [10, 20, 50];
  @Input() totalResVisible = false;
  @Input() totalCount: number;
  @Output() nextPage = new EventEmitter();

  handlePage(event: PageEvent): void {
    this.nextPage.next(event);
  }
}
